export enum QueryParamsHandlingType{
  Replace = "replace",
  Preserve = "preserve",
  MergeAll = "mergeAll",
  MergeGiven = "mergeGiven",
}
